import React from 'react'
import Carousel from '../components/Carousel';
import Gallary from './Gallary';
import Contact from './Contact';
import About from './About';
import {imageList} from '../data/data';
import { carouselImages, galleryHome } from '../data/data';
import { Helmet } from 'react-helmet-async';

const isHomePage = window.location.origin.includes('home') ? true : false;

const Home = () => {
    return (
        <>
        
        <Carousel carausel={carouselImages}/> 
        <About />
        <Gallary imgList={isHomePage ? galleryHome : imageList}/>
        <Contact/>
        <Helmet>
            <title>Home - Sofa bazaar | Premium Sofas & Furniture in Ambikapur</title>
            <meta name='description' content='Welcome to sofa bazaar, your premier sofa showroom in Ambikapur. Discover a vast selection of high-quality, stylish sofas and furniture to suit any home. Visit us today to find the perfect addition to your living space!'></meta>
            <link rel='canonical' href='https://www.sofabaazar.com/home' />
        </Helmet>
        </>
    )
}

export default Home
